import React from "react";
import { EqupRoundLoaderWithoutOverlay } from "../Components/Common/Loader/RoundLoader";
import NavigationWrapper from "../Layouts/NavigationWrapper";

const RetryFallback = ({ retry }) => {
  return (
    <React.Fragment>
      <NavigationWrapper show={["public", "private"]} runQueries={false} />
      <EqupRoundLoaderWithoutOverlay />
    </React.Fragment>
  );
};

export default RetryFallback;
